export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <img
                  src="/favicon.png"
                  alt="Olympic Academy Logo"
                  className="w-12 h-12 object-contain"
                />
                <span
                  className="text-2xl font-bold"
                  style={{
                    fontFamily: '"Inter", "Roboto", sans-serif',
                    fontWeight: "700",
                  }}
                >
                  Olympic Academy
                </span>
              </div>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Khai phóng tiềm năng và dẫn dắt thế hệ tương lai Việt Nam trong
                kỷ nguyên số. Đào tạo chuyên sâu Toán học, Lập trình và Trí tuệ
                Nhân tạo với tinh thần Olympic: Xuất sắc - Tôn trọng - Tình bạn.
              </p>
              <div className="flex space-x-4">
                <a
                  href="#"
                  className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill text-white"></i>
                </a>
                {/* <a
                  href="#"
                  className="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors cursor-pointer"
                >
                  <i className="ri-twitter-fill text-white"></i>
                </a> */}
                <a
                  href="#"
                  className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors cursor-pointer"
                >
                  <i className="ri-youtube-fill text-white"></i>
                </a>
                {/* <a
                  href="#"
                  className="w-10 h-10 bg-blue-700 rounded-full flex items-center justify-center hover:bg-blue-800 transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-white"></i>
                </a> */}
              </div>
            </div>

            <div>
              <h4 className="text-xl font-semibold mb-6">Chương trình</h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="#"
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Toán học Olympic
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Lập trình Competitive
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Trí tuệ Nhân tạo
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Khóa học Online
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-xl font-semibold mb-6">Liên hệ</h4>
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <i className="ri-map-pin-line text-blue-400 mt-1"></i>
                  <span className="text-gray-300">
                    34 Lê Duẩn, phường Sài Gòn, TP.HCM
                  </span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-phone-line text-green-400"></i>
                  <span className="text-gray-300">08 9999 0101</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-mail-line text-yellow-400"></i>
                  <span className="text-gray-300">contact@olympic.com.vn</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-time-line text-red-400"></i>
                  <span className="text-gray-300">T2-T7: 8:00 - 20:00</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8">
            <p className="text-gray-400 text-center">© 2024 Olympic Academy</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
